import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  container: {
    textAlign: 'left',
  },
  imageContainer: {
    width: '100%',
  },  
  image: {
    display: 'block',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    //backgroundPosition: 'center center!important',
    width: '100%',
    height: '50px',
    minWidth:'100px',
    maxWidth:'240px',
    minHeight: '20px',
    maxHeight: '82px',

    backgroundImage: 'url("/images/spw_logo.png")',
  },
});

function SpwLogo(props) {
  const { classes } = props;

  return (
    <div className={classes.container}>
      <div className={classes.imageContainer}>
        <div className={classes.image} />
      </div>
    </div>
  );
}

SpwLogo.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SpwLogo);